var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Play",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon_library</title>
  <g id="svg-fg">
    <path d="M18.77,31.94q0,6.09,0,12.19A2.64,2.64,0,0,0,23,46.55c6.92-4,13.82-8.13,20.78-12.1a2.74,2.74,0,0,0,0-4.87c-6.95-4-13.85-8.08-20.77-12.11a2.66,2.66,0,0,0-4.22,2.44Q18.77,25.92,18.77,31.94Z"/>
    <path d="M18.77,31.94q0-6,0-12A2.66,2.66,0,0,1,23,17.46c6.93,4,13.83,8.11,20.77,12.11a2.74,2.74,0,0,1,0,4.87c-7,4-13.85,8.06-20.78,12.1a2.64,2.64,0,0,1-4.18-2.42Q18.76,38,18.77,31.94Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/play.svg